import { getListsByIds } from '@/apis/lists';

export const loadLists = async ({ token, listIds }: { token: string; listIds: number[] }) => {
  if (listIds.length === 0) return { lists: [], isMissing: false };
  const lists = (await getListsByIds(token, listIds)).map(({ id, name }) => ({ id, label: name }));
  return { lists, isMissing: lists.length !== listIds.length };
};
